import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCheckboxBase } from '@/fo/ui/kit/checkbox/base';

import { onSubscribeEmailToNewsletter } from '../../api/onSubscribeEmailToNewsletter';

import { styles } from './FormFooter.styles';

export interface FormFooterProps {
  type: 'review' | 'question';
  pending?: boolean;
  isDirty?: boolean;
  photoLoading?: boolean;
  email?: string;
  isSubscribed?: boolean;
  onSubmit?: () => void | Promise<void>;
}

export function FormFooter({
  type,
  pending,
  isDirty,
  photoLoading,
  email,
  isSubscribed: initialIsSubscribed,
  onSubmit
}: FormFooterProps) {
  const t = useTranslations();

  const slots = styles();

  const [isPrivacyAgreed, setIsPrivacyAgreed] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(
    initialIsSubscribed ?? false
  );

  const buttonText =
    type === 'review'
      ? t('review.form.sendReview')
      : t('review.form.sendQuestion');

  const handleMarketingChange = (checked: boolean) => {
    setIsSubscribed(checked);
  };

  const handleSubmit = async () => {
    if (onSubmit) {
      await onSubmit();
    }

    if (!initialIsSubscribed && isSubscribed && email) {
      await onSubscribeEmailToNewsletter(email);
    }
  };

  return (
    <div className={slots.base()}>
      <UiKitButtonBase
        disabled={pending || !isDirty || photoLoading || !isPrivacyAgreed}
        className={slots.button()}
        type="submit"
        onClick={handleSubmit}
      >
        {buttonText}
      </UiKitButtonBase>
      {!initialIsSubscribed && (
        <UiKitCheckboxBase
          checked={isSubscribed}
          label={t.rich('form.label.agreementMarketing', {
            link: (chunks) => (
              <a
                target="_blank"
                rel="noreferrer"
                href="/legal/agreement-subscriber/"
                className={slots.link()}
              >
                {chunks}
              </a>
            )
          })}
          onChange={handleMarketingChange}
        />
      )}
      <UiKitCheckboxBase
        checked={isPrivacyAgreed}
        onChange={setIsPrivacyAgreed}
        label={t.rich(
          type === 'review'
            ? 'form.label.agreementPrivacyReview'
            : 'form.label.agreementPrivacyQuestion',
          {
            linkPD: (chunks) => (
              <a
                target="_blank"
                rel="noreferrer"
                href="/legal/agreement-users/"
                className={slots.link()}
              >
                {chunks}
              </a>
            ),
            linkPrivacy: (chunks) => (
              <a
                target="_blank"
                rel="noreferrer"
                href="/legal/politika-konfidentsialnosti/"
                className={slots.link()}
              >
                {chunks}
              </a>
            )
          }
        )}
      />
    </div>
  );
}
